import type { FaireProductEntity } from "../../entity_types/product";

export const p_6837yh7p55: FaireProductEntity = {
  token: "p_6837yh7p55",
  type: "product",
  name: "Balance Essential Oil Roll-On | Lavender Lemon Rose",
  brandToken: "b_ctk8411a4a",
  brandName: "Thistle Farms",
  imageUrl:
    "https://cdn.faire.com/fastly/a8fd4ec0ac22e8afe3ef937438c783ea08ef98900a149ee3aed7639047059b6a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1611262554128c39eaa8d5e150768279cb8cfccce1ffae1e2cf50b47f625e67f.png",
    "https://cdn.faire.com/fastly/e542a0d30635be28654b9fa362828595fb82c22c3df952d4dcfa161732758fb2.png",
    "https://cdn.faire.com/fastly/a823103a740b82dceb27ca2b5d2855556138ae3d493830e576e6e210c5dd8443.png",
  ],
  priceDollars: 7.5,
  description:
    "Elevate your retail offerings with our natural, woman-made essential oil roll-ons. Designed for convenience, these easy-to-use applicators bring the transformative benefits of essential oils to your customers in a mess-free, portable format.\n\nBalance - Lavender, Lemon + Rose Geranium\nA centering essential oil blend that harmonizes your body and mind.\n\nProduct Details:\n\nSize: 10 ml per roll-on\nPackaging: Sold in cases of 6\nMSRP per 10 ml bottle: $15.00",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:01.717Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
